// extracted by mini-css-extract-plugin
export default {"container":"FeedbackForm_container__paz9t","loadingContainer":"FeedbackForm_loadingContainer__Y2WyV","loadingContent":"FeedbackForm_loadingContent__0GhiU"};